<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3">
      <div class="font20">Mentor Management</div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-12">
        <div class="mentor-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Mentors</div>
            <div>
              <button
                class="btn btn-outline-secondary btn-sm"
                data-toggle="modal"
                data-target="#addMentorModal"
              >
                Add Mentor
              </button>
            </div>
          </div>
          <div class="card-body">
            <p *ngIf="mentors?.length === 0">No mentors added</p>
            <div class="pb-4 pt-3">
              <div
                *ngFor="let mentor of mentors"
                class="click mentorCard"
                [ngClass]="{ isActive: mentor?.id === mentorId }"
              >
                <div class="px-4 py-2 d-flex  align-items-center border-radius">
                  <div
                    class="d-flex  align-items-center"
                    (click)="setMentor(mentor?.id, mentor.mentees)"
                  >
                    <div class="profile mr-3 ">
                      <img src="{{
                          mentor?.mentor?.user?.avatarUrl
                            ? mentor?.mentor?.user?.avatarUrl
                            : 'assets/images/avatar.jpg'
                        }}" alt="" class="w-10 rounded-circle" width="50" height="50"
                      />
                    </div>
                    <div class="mr-5">
                      <p class="mb-1 font-bold">
                        {{ mentor?.mentor?.user?.fullName }}
                      </p>
                      <p class="mb-0 text-grey font14">
                        {{ mentor?.mentor?.user.username }}
                      </p>
                    </div>
                  </div>
                  <div class="click dlt-check" (click)="deleteMentor(mentor?.id)">
                    <!-- <img src="assets/images/close.png" alt="" /> -->
                    <i class="far fa-times-circle dark icon"></i>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12 sm-mt" *ngIf="!emptyMentee">
        <div class="mentor-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Mentees</div>
            <div>
              <button
                class="btn btn-outline-secondary btn-sm"
                [disabled]="!mentorId"
                data-toggle="modal"
                data-target="#addMenteesModal"
              >
                Assign Mentees
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="py-4  px-2">
              <div class="row">
                <div *ngIf="mentees.length == 0 && mentorId" class="px-4">
                  This mentor has no mentees
                </div>
                <div *ngIf="!mentorId" class="px-4">
                  Please select a mentor to view and assign mentees
                </div>
                <div
                  class="col-lg-6 col-sm-12 my-3"
                  *ngFor="let mentee of mentees"
                >
                  <div
                    class="bg-grey p-4 d-flex  align-items-center border-radius"
                  >
                    <div class="profile mr-3">
                      <img src="{{
                          mentee?.user?.avatarUrl
                            ? mentee?.user?.avatarUrl
                            : 'assets/images/avatar.jpg'
                        }}" alt="" class="w-10 rounded-circle" width="50" height="50"
                      />
                    </div>
                    <div>
                      <p class="mb-1 font-bold">{{ mentee?.user?.fullName }}</p>
                      <p class="mb-0 text-grey font14">
                        {{ mentee?.user?.username }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12 sm-mt" *ngIf="emptyMentee">
        <div class="mentor-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Mentors</div>
            <div>
              <button
                class="btn btn-outline-secondary btn-sm"
                data-toggle="modal"
                data-target="#addModal"
              >
                Add Mentee
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="py-4 px-2">
              <div class="row">
                <div class="col-lg-2 col-sm-12"></div>
                <div class="col-lg-8 col-sm-12 py-4">
                  <div class="text-center">
                    <img
                      src="assets/images/emptyMentee.svg"
                      alt=""
                      class="w-100"
                    />
                    <p class="font26  mt-4">Nobody to mentor yet</p>
                    <p>
                      Add one or more members of your organisation to be
                      mentored
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!-- Modal -->
<div
  class="modal fade"
  id="addMentorModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addMentorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="nav-card bg-white px-4 py-3">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Individuals-tab"
                data-toggle="pill"
                href="#Individuals"
                role="tab"
                aria-controls="Individuals"
                aria-selected="true"
                >Mentors</a
              >
            </li>
          </ul>
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="Individuals"
            role="tabpanel"
            aria-labelledby="Individuals-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filter(query.value)" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="let staff of staffs | paginate
                    : {
                        id: 'listing_pagination',
                        itemsPerPage: paginationInfo.size,
                        currentPage: paginationInfo.number,
                        totalItems: paginationInfo.totalElements
                      }
                    ; index as i"
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselectMentors(staff)"
                      id="checkbox{{ i }}"
                      class="checkbox"
                    />
                    <label for="checkbox{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="{{
                              staff?.user?.avatarUrl
                                ? staff?.user?.avatarUrl
                                : 'assets/images/avatar.jpg'
                              }}" alt="" class="w-10 rounded-circle" width="50" height="50"
                            />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ staff?.user?.fullName }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ staff?.user?.username }}
                            </p>
                          </div>
                        </div>
                        <div class="check d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center sm-flex-column">
                <pagination-controls id="listing_pagination" (pageChange)="navigatePage($event)"></pagination-controls>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between p-3">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-secondary btn-md"
          (click)="addMentors()"
        >
          Add Mentor
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="addMenteesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addMenteesModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="nav-card bg-white px-4 py-3">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Individuals-tab"
                data-toggle="pill"
                href="#Individuals"
                role="tab"
                aria-controls="Individuals"
                aria-selected="true"
                >Mentees</a
              >
            </li>
          </ul>
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="Individuals"
            role="tabpanel"
            aria-labelledby="Individuals-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                  />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="let staff of staffs | paginate
                    : {
                        id: 'listing_pagination',
                        itemsPerPage: paginationInfo.size,
                        currentPage: paginationInfo.number,
                        totalItems: paginationInfo.totalElements
                      }
                    ; index as i"
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselectMentees(staff)"
                      id="checkboxM{{ i }}"
                      class="checkbox"
                    />
                    <label for="checkboxM{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="{{
                              staff?.user?.avatarUrl
                                ? staff?.user?.avatarUrl
                                : 'assets/images/avatar.jpg'
                              }}" alt="" class="w-10 rounded-circle" width="50" height="50"
                            />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ staff?.user?.fullName }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ staff?.user?.username }}
                            </p>
                          </div>
                        </div>
                        <div class="check  d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center sm-flex-column">
                <pagination-controls id="listing_pagination" (pageChange)="navigatePage($event)"></pagination-controls>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between p-3">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-secondary btn-md"
          (click)="assignMentees()"
        >
          Assign
        </button>
      </div>
    </div>
  </div>
</div>
